import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {ConstantSpeedIcon.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 48
}

/**
 * Stateless function representing a ConstantSpeed icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <ConstantSpeedIcon width={12} />
 */
const ConstantSpeedIcon = props => (
    <SvgIcon {...props}>
        <path
            d={`M29,27a4.51,4.51,0,1,1-8.84-1.26l-4.44-6.27a0.9,0.9,0,0,1,1.15-1.32l0.09,0,6.2,4.49A4.51,
            4.51,0,0,1,29,27ZM24.47,8.61a18.41,18.41,0,0,1,13.14,31.3L37.5,40a1.27,1.27,0,0,1-1.8,
            0h0l-2.57-2.59a1.27,1.27,0,1,1,1.8-1.8l1.61,1.67a15.9,15.9,0,0,0,3.73-9H38a1.27,1.27,0,0,1,
            0-2.51h2.28a15.9,15.9,0,0,0-3.72-9l-1.62,1.61a1.27,1.27,0,1,1-1.8-1.8l1.61-1.65a15.9,15.9,
            0,0,0-9-3.72v2.28a1.27,1.27,0,0,1-2.51,0V11.19a15.9,15.9,0,0,0-9.05,3.72l0.34,0.38a1.27,
            1.27,0,0,1-1.77,1.76l-0.34-.34a15.9,15.9,0,0,0-3.76,9h2.28a1.27,1.27,0,0,1,0,2.51H8.65a15.9,
            15.9,0,0,0,3.72,9.05l0.3-.3h0L14,35.71a1.27,1.27,0,0,1,1.8,1.8h0l-0.84.84-0.08.15h0l-1.56,
            1.56a1.27,1.27,0,0,1-1.8,0h0a18.41,18.41,0,0,1,0-26h0a18.29,18.29,0,0,1,13-5.45h0ZM9.12,7.45L7.77,
            10.17,5.05,11.52l5.32,1.25Z`}
        />
    </SvgIcon>
)

ConstantSpeedIcon.defaultProps = defaultProps

export { ConstantSpeedIcon }
